import { useLazyQuery } from "@apollo/client";
import { GET_COMPANY_EQUIPMENTS } from "components/gql/gql_queries_export";
import { GetAlertData } from "contexts/AlertContext";
import { GetData } from "contexts/DataContext";
import {
  consoleBeauty,
  isIdentical,
  isObjectEmpty,
  logGQLError,
} from "data/functions";

export function GetEquipmentsQuery() {
  const queryName = "GetEquipments";
  const { setAlert } = GetAlertData();
  const { dataObj, forceSetDataObj } = GetData();
  const [refetch, variables] = useLazyQuery(GET_COMPANY_EQUIPMENTS, {
    fetchPolicy: "no-cache",
    // notifyOnNetworkStatusChange: true,
    // variables: {
    //   companyUuid: cInfo?.UUID,
    // },
    onCompleted: (data) => {
      let res = data?.export_companyEquipments;
      if (isObjectEmpty(res)) {
        forceSetDataObj([], "equipments");
      } else if (!isIdentical(res, dataObj?.equipments)) {
        consoleBeauty("Получен список оборудования", "GraphQL", "darkgreen");
        forceSetDataObj(res, "equipments");
      }
    },
    onError: (e) => {
      if (dataObj?.payType !== "self-service") {
        setAlert("Ошибка при получении оборудования!", "error");
      }
      forceSetDataObj([], "equipments");
      logGQLError(queryName, e);
    },
  });
  return [refetch, variables];
}
